import { JoyField, JoyObject, JoyObjectType, JoyDataService, isString, isStringArray, compareStringArrays, } from 'joy-core';
export default class JoyDeal extends JoyObject {
    /**
     * Create a new JoyDeal object.
     * @param data A map of JoyField/value pairs that define the object properties.
     */
    constructor(data) {
        super({
            id: data[JoyField.id],
            objectId: data[JoyField.objectId],
            createdAt: data[JoyField.createdAt],
            createdBy: data[JoyField.createdBy],
        });
        this.fields = [JoyField.deal, JoyField.email, JoyField.name, JoyField.users];
        this.objectType = JoyObjectType.group;
        this.update = (update) => {
            console.log('new updates for deal: ' + this.id);
            let changes = [];
            let dealId = update[JoyField.deal];
            if (isString(dealId) && this._dealId !== dealId) {
                this._dealId = dealId;
                changes.push(JoyField.deal);
            }
            let email = update[JoyField.name];
            if (isString(email) && this._clientEmail !== email) {
                this._clientEmail = email;
                changes.push(JoyField.email);
            }
            let name = update[JoyField.description];
            if (isString(name) && this._clientName !== name) {
                this._clientName = name;
                changes.push(JoyField.name);
            }
            let users = update[JoyField.users];
            if (isStringArray(users) && !compareStringArrays(users, this._users)) {
                this._users = users;
                changes.push(JoyField.users);
            }
            if (changes.length > 0) {
                super.notifyObservers(changes);
            }
        };
        if (!isString(data[JoyField.deal])) {
            return null;
        }
        this._dealId = data[JoyField.deal];
        if (!isString(data[JoyField.name])) {
            return null;
        }
        this._clientEmail = data[JoyField.name];
        if (!isString(data[JoyField.description])) {
            return null;
        }
        this._clientName = data[JoyField.description];
        if (!isStringArray(data[JoyField.users])) {
            return null;
        }
        this._users = data[JoyField.users];
        this.initialUpdate = JoyDeal.fields;
        let listenerData = new Map();
        listenerData[JoyField.objectType] = this.objectType;
        listenerData[JoyField.id] = this.id;
        this.listener = JoyDataService.instance.documentListener(listenerData, this.update);
    }
    get dealId() {
        return this._dealId;
    }
    get clientEmail() {
        return this._clientEmail;
    }
    get clientName() {
        return this._clientName;
    }
    get users() {
        return this._users;
    }
}
//# sourceMappingURL=JoyDeal.js.map